import React, { ReactNode } from 'react';

import { Container, MainContent } from './styles';
import SideBar from '../SideBar';
import useFavicon, { DEFAULT_FAVICON_FILE_NAME } from '../../hooks/useFavicon';

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  // The back office is not survey branded, so it always uses the platform
  // favicon. `public/index.html` only carries a neutral placeholder, since the
  // questionnaire pages resolve their own favicon from the project type.
  useFavicon({
    faviconFileName: DEFAULT_FAVICON_FILE_NAME,
    persist: false,
  });

  return (
    <Container>
      <SideBar name="Victor Neu" />
      <MainContent>{children}</MainContent>
    </Container>
  );
};

export default DashboardLayout;
